export enum ENDPOINTS {
  // BASE URLs
  DEV_BASE_URL = "https://dmc-api-dev.mrk-mdlwr.com",
  TEST_BASE_URL = "https://dmc-api-test.mrk-mdlwr.com",
  DEMO_BASE_URL = "https://dmc-api-demo.mrk-mdlwr.com",
  PROD_BASE_URL = "https://dmc-api-prod.mrk-mdlwr.com",
  LATAM_PROD_BASE_URL = "https://dmc-api-latam-prod.mrk-mdlwr.com",
  LATAM_SIT_BASE_URL = "https://dmc-api-latam-sit.mrk-mdlwr.com",
  EUCAN_SIT_BASE_URL = "https://dmc-api-eucan-sit.mrk-mdlwr.com",
  EURAM_PROD_BASE_URL = "https://dmc-api-euram-prod.mrk-mdlwr.com",
  EURAM_SIT_BASE_URL = "https://dmc-api-euram-sit.mrk-mdlwr.com",
  APAC_PROD_BASE_URL = "https://dmc-api-apac-prod.mrk-mdlwr.com",
  APAC_SIT_BASE_URL = "https://dmc-api-apac-sit.mrk-mdlwr.com",
  RU_PROD_BASE_URL = "https://dmc-api-ru-prod.mrk-mdlwr.com",
  RU_SIT_BASE_URL = "https://dmc-api-ru-sit.mrk-mdlwr.com",
  US_PROD_BASE_URL = "https://dmc-api-us-prod.mrk-mdlwr.com",
  US_SIT_BASE_URL = "https://dmc-api-us-sit.mrk-mdlwr.com",

  DEV_DEEPLINK = "https://dmc-api-dev.mrk-mdlwr.com/deeplink",
  TEST_DEEPLINK = "https://dmc-api-test.mrk-mdlwr.com/deeplink",
  DEMO_DEEPLINK = "https://dmc-api-demo.mrk-mdlwr.com/deeplink",
  // PROD currently playing role of EUCAN_PROD
  PROD_DEEPLINK = "https://dmc-api-prod.mrk-mdlwr.com/deeplink",
  LATAM_PROD_DEEPLINK = "https://dmc-api-latam-prod.mrk-mdlwr.com/deeplink",
  LATAM_SIT_DEEPLINK = "https://dmc-api-latam-sit.mrk-mdlwr.com/deeplink",
  EUCAN_SIT_DEEPLINK = "https://dmc-api-eucan-sit.mrk-mdlwr.com/deeplink",
  EURAM_PROD_DEEPLINK = "https://dmc-api-euram-prod.mrk-mdlwr.com/deeplink",
  EURAM_SIT_DEEPLINK = "https://dmc-api-euram-sit.mrk-mdlwr.com/deeplink",
  APAC_PROD_DEEPLINK = "https://dmc-api-apac-prod.mrk-mdlwr.com/deeplink",
  APAC_SIT_DEEPLINK = "https://dmc-api-apac-sit.mrk-mdlwr.com/deeplink",
  RU_PROD_DEEPLINK = "https://dmc-api-ru-prod.mrk-mdlwr.com/deeplink",
  RU_SIT_DEEPLINK = "https://dmc-api-ru-sit.mrk-mdlwr.com/deeplink",
  US_PROD_DEEPLINK = "https://dmc-api-us-prod.mrk-mdlwr.com/deeplink",
  US_SIT_DEEPLINK = "https://dmc-api-us-sit.mrk-mdlwr.com/deeplink",

  DEV_TRANSACTIONAL_EMAILS = "https://dmc-api-dev.mrk-mdlwr.com/transactional-emails",
  TEST_TRANSACTIONAL_EMAILS = "https://dmc-api-test.mrk-mdlwr.com/transactional-emails",
  DEMO_TRANSACTIONAL_EMAILS = "https://dmc-api-demo.mrk-mdlwr.com/transactional-emails",
  // PROD currently playing role of EUCAN_PROD
  PROD_TRANSACTIONAL_EMAILS = "https://dmc-api-prod.mrk-mdlwr.com/transactional-emails",
  LATAM_PROD_TRANSACTIONAL_EMAILS = "https://dmc-api-latam-prod.mrk-mdlwr.com/transactional-emails",
  LATAM_SIT_TRANSACTIONAL_EMAILS = "https://dmc-api-latam-sit.mrk-mdlwr.com/transactional-emails",
  EUCAN_SIT_TRANSACTIONAL_EMAILS = "https://dmc-api-eucan-sit.mrk-mdlwr.com/transactional-emails",
  EURAM_PROD_TRANSACTIONAL_EMAILS = "https://dmc-api-euram-prod.mrk-mdlwr.com/transactional-emails",
  EURAM_SIT_TRANSACTIONAL_EMAILS = "https://dmc-api-euram-sit.mrk-mdlwr.com/transactional-emails",
  APAC_PROD_TRANSACTIONAL_EMAILS = "https://dmc-api-apac-prod.mrk-mdlwr.com/transactional-emails",
  APAC_SIT_TRANSACTIONAL_EMAILS = "https://dmc-api-apac-sit.mrk-mdlwr.com/transactional-emails",
  RU_PROD_TRANSACTIONAL_EMAILS = "https://dmc-api-ru-prod.mrk-mdlwr.com/transactional-emails",
  RU_SIT_TRANSACTIONAL_EMAILS = "https://dmc-api-ru-sit.mrk-mdlwr.com/transactional-emails",
  US_PROD_TRANSACTIONAL_EMAILS = "https://dmc-api-us-prod.mrk-mdlwr.com/transactional-emails",
  US_SIT_TRANSACTIONAL_EMAILS = "https://dmc-api-us-sit.mrk-mdlwr.com/transactional-emails",

  DEV_CONSENT_HUB_CUSTOMER = "https://coh-api-dev.mrk-mdlwr.com/customer",
  TEST_CONSENT_HUB_CUSTOMER = "https://coh-api-test.mrk-mdlwr.com/customer",
  SIT_CONSENT_HUB_CUSTOMER = "https://coh-api-sit.mrk-mdlwr.com/customer",
  DEMO_CONSENT_HUB_CUSTOMER = "https://coh-api-demo.mrk-mdlwr.com/customer",
  // PROD currently playing role of EUCAN_PROD
  PROD_CONSENT_HUB_CUSTOMER = "https://coh-api-prod.mrk-mdlwr.com/customer",
  LATAM_PROD_CONSENT_HUB_CUSTOMER = "https://coh-api-latam-prod.mrk-mdlwr.com/customer",
  LATAM_SIT_CONSENT_HUB_CUSTOMER = "https://coh-api-latam-sit.mrk-mdlwr.com/customer",
  EUCAN_SIT_CONSENT_HUB_CUSTOMER = "https://coh-api-eucan-sit.mrk-mdlwr.com/customer",
  EURAM_PROD_CONSENT_HUB_CUSTOMER = "https://coh-api-euram-prod.mrk-mdlwr.com/customer",
  EURAM_SIT_CONSENT_HUB_CUSTOMER = "https://coh-api-euram-sit.mrk-mdlwr.com/customer",
  APAC_PROD_CONSENT_HUB_CUSTOMER = "https://coh-api-apac-prod.mrk-mdlwr.com/customer",
  APAC_SIT_CONSENT_HUB_CUSTOMER = "https://coh-api-apac-sit.mrk-mdlwr.com/customer",
  RU_PROD_CONSENT_HUB_CUSTOMER = "https://coh-api-ru-prod.mrk-mdlwr.com/customer",
  RU_SIT_CONSENT_HUB_CUSTOMER = "https://coh-api-ru-sit.mrk-mdlwr.com/customer",
  US_PROD_CONSENT_HUB_CUSTOMER = "https://coh-api-us-prod.mrk-mdlwr.com/customer",
  US_SIT_CONSENT_HUB_CUSTOMER = "https://coh-api-us-sit.mrk-mdlwr.com/customer",

  // COH WIDGET
  DEV_COH_WIDGET_BASE_URL = "https://coh-widget-dev.mrk-mdlwr.com",
  TEST_COH_WIDGET_BASE_URL = "https://coh-widget-test.mrk-mdlwr.com",
  DEMO_COH_WIDGET_BASE_URL = "https://coh-widget-demo.mrk-mdlwr.com",
  PROD_COH_WIDGET_BASE_URL = "https://coh-widget-prod.mrk-mdlwr.com",
  LATAM_PROD_COH_WIDGET_BASE_URL = "https://coh-widget-latam-prod.mrk-mdlwr.com",
  LATAM_SIT_COH_WIDGET_BASE_URL = "https://coh-widget-latam-sit.mrk-mdlwr.com",
  EUCAN_SIT_COH_WIDGET_BASE_URL = "https://coh-widget-eucan-sit.mrk-mdlwr.com",
  EURAM_PROD_COH_WIDGET_BASE_URL = "https://coh-widget-euram-prod.mrk-mdlwr.com",
  EURAM_SIT_COH_WIDGET_BASE_URL = "https://coh-widget-euram-sit.mrk-mdlwr.com",
  APAC_PROD_COH_WIDGET_BASE_URL = "https://coh-widget-apac-prod.mrk-mdlwr.com",
  APAC_SIT_COH_WIDGET_BASE_URL = "https://coh-widget-apac-sit.mrk-mdlwr.com",
  RU_PROD_COH_WIDGET_BASE_URL = "https://coh-widget-ru-prod.mrk-mdlwr.com",
  RU_SIT_COH_WIDGET_BASE_URL = "https://coh-widget-ru-sit.mrk-mdlwr.com",
  US_PROD_COH_WIDGET_BASE_URL = "https://coh-widget-us-prod.mrk-mdlwr.com",
  US_SIT_COH_WIDGET_BASE_URL = "https://coh-widget-us-sit.mrk-mdlwr.com",

  // TR Emails endpoint keys
  DEV_TRANSACTIONAL_EMAILS_KEY = "", // endpoint doesn't seem to be used in any FEP (03/2023)
  TEST_TRANSACTIONAL_EMAILS_KEY = "",
  DEMO_TRANSACTIONAL_EMAILS_KEY = "",
  // PROD currently playing role of EUCAN_PROD
  PROD_TRANSACTIONAL_EMAILS_KEY = "",
  LATAM_PROD_TRANSACTIONAL_EMAILS_KEY = "",
  LATAM_SIT_TRANSACTIONAL_EMAILS_KEY = "",
  EUCAN_SIT_TRANSACTIONAL_EMAILS_KEY = "",
  EURAM_PROD_TRANSACTIONAL_EMAILS_KEY = "",
  EURAM_SIT_TRANSACTIONAL_EMAILS_KEY = "buFK68QIyrTJ3H90LDCeaLGX8NqwwFT6p48Ts824",
  APAC_PROD_TRANSACTIONAL_EMAILS_KEY = "",
  APAC_SIT_TRANSACTIONAL_EMAILS_KEY = "",
  RU_PROD_TRANSACTIONAL_EMAILS_KEY = "",
  RU_SIT_TRANSACTIONAL_EMAILS_KEY = "",
  US_PROD_TRANSACTIONAL_EMAILS_KEY = "",
  US_SIT_TRANSACTIONAL_EMAILS_KEY = "",
}
